import { cva } from "class-variance-authority";

export const inputVariants = cva(
    "dark:bg-iron-950 dark:ring-offset-iron-950 w-full flex h-10 rounded-r-lg border  bg-white px-3 py-2 text-sm shadow-xs ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-iron-500 focus-visible:outline-none  focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-iron-800 dark:placeholder:text-iron-400 dark:focus-visible:ring-iron-300",
    {
        variants: {
            variant: {
                default:
                    "focus-visible:border-z-primary-300 focus-visible:ring-z-primary-100 border-iron-300",
                error: "focus-visible:border-error-300 focus-visible:ring-error-100 border-error-300",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);
